<template>
  <div class="card mb-3">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> از تاریخ</label
          >
          <Datepicker
            simple
            auto-submit
            id="from-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :max="fromDateMax"
            v-model="fromDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> تا تاریخ</label
          >
          <Datepicker
            simple
            auto-submit
            id="to-date"
            locale="fa"
            input-format="YYYY-MM-DD"
            :min="fromDate"
            :max="toDateMax"
            v-model="toDate"
            :locale-config="{
              fa: {
                displayFormat: 'jYYYY/jMM/jDD',
                lang: { label: 'شمسی' },
              },
            }"
          />
        </div>
        <div class="form-group col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> سازمان</label
          >
          <select required class="form-control custom-select" v-model="organ">
            <option value="0" selected disabled>انتخاب کنید</option>
            <option value="1170">سازمان مساجد</option>
            <option value="1166">جهاد دانشگاهی</option>
          </select>
        </div>
        <div class="form-group col-md-3">
          <label
            ><label style="color: red; height: 2px;">*</label> نوع تراکنش</label
          >
          <select required class="form-control custom-select" v-model="type">
            <option value="0" selected disabled>انتخاب کنید</option>
            <option value="1">خرید </option>
            <option value="2"> شارژ</option>
          </select>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>شماره کارت</label>
            <div class="input-group">
              <input
                type="tel"
                class="form-control text-center"
                v-mask="'####-####-####-####'"
                v-model="pan"
                dir="ltr"
                style="direction: ltr !important"
              />
              <span
                class="input-group-btn"
                v-if="pan && pan.replace(/-/g, '').length == 16"
              ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="display: flex; justify-content: end">
        <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-info btn-block" @click="getFullExelPath">
            دریافت فایل اکسل کل
          </button>
        </div>
        <div v-if="isSearched" class="col-md-3">
          <button class="btn btn-warning btn-block" @click="getExelPath">
            دریافت فایل اکسل
          </button>
        </div>
        <div class="col-md-3">
          <button
            class="btn btn-primary btn-block"
            @click="submit"
            :disabled="!fromDate || type == 0 || !toDate || organ == 0"
          >
            <i class="si si-magnifier"></i>
            جستجو
          </button>
        </div>
      </div>
      <div class="alert alert-info mt-4 mb-0" v-if="!rows.length && isSearched">
        <p class="mb-0">اطلاعاتی یافت نشد</p>
      </div>
      <hr v-if="rows.length" />
      <div class="row">
        <div class="col-md-1">
          <div class="form-group">
            <label>تعداد</label>
            <select v-model="perPage" class="form-control">
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="200">200</option>
            </select>
          </div>
        </div>
        <div class="col-md-8"></div>
        <div class="col-md-3 text-left" style="margin-top:26px">
          تعداد کل ردیف ها : {{ count }} ردیف
        </div>
      </div>
      <table class="table table-hover table-bordered mb-0" v-if="rows.length">
        <thead>
          <tr>
            <th>نام سازمان</th>
            <th>مبلغ</th>
            <th>عملیات</th>
            <th>وضعیت</th>
            <th>شماره کارت</th>
            <th>شماره پایانه</th>
            <th>زمان</th>
            <th>ساعت</th>
            <th>شماره مرجع</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ row.organName }}</td>
            <td>
              {{
                row.amount
                  ? new Intl.NumberFormat("en-IR", {
                      maximumSignificantDigits: 20,
                    }).format(row.amount)
                  : "0"
              }}
              ریال
            </td>
            <td>{{ row.operation }}</td>
            <td v-if="row.status"><i class="ti-check text-success"></i></td>
            <td v-else><i class="ti-close text-danger"></i></td>
            <td>{{ row.pan }}</td>
            <td>{{ row.terminal }}</td>
            <td>
              {{
                row.persianDate.replace(/\//g, "").slice(0, 4) +
                  "/" +
                  row.persianDate.replace(/\//g, "").slice(4, 6) +
                  "/" +
                  row.persianDate.replace(/\//g, "").slice(6, 8)
              }}
            </td>
            <td>{{ row.persianTime }}</td>
            <td>{{ row.referenceno }}</td>
          </tr>
        </tbody>
      </table>
      <div class="row mt-3" v-if="pages.length > 1" style="overflow-x: hidden;">
        <div class="col-12" style="overflow-x: auto;">
          <ul class="pagination pagination-circled">
            <li class="page-item" v-if="currentPage > 1">
              <a class="page-link" href="#" v-on:click="currentPage--"
                ><i class="icon ion-ios-arrow-forward"></i
              ></a>
            </li>
            <li
              :class="currentPage == page ? 'page-item active' : 'page-item'"
              v-for="(page, index) in pages"
              :key="index"
            >
              <div style="display: flex; flex-direction: row;">
                <span class="page-link ml-1" v-if="page > pages[index - 1] + 1">
                  ...
                </span>
                <a class="page-link" href="#" v-on:click="currentPage = page">{{
                  page
                }}</a>
              </div>
            </li>
            <li class="page-item" v-if="pages.length != currentPage">
              <a class="page-link" href="#" v-on:click="currentPage++"
                ><i class="icon ion-ios-arrow-back"></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
      <p v-if="rows.length" class="mt-4 mb-0">تعداد کل : {{ count }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
  name: "TransactionsList",
  data() {
    return {
      showLoading: false,
      isSearched: false,
      rows: [],
      fromDate: "",
      toDateMax: moment().format("jYYYY-jMM-jDD"),
      fromDateMax: moment().format("jYYYY-jMM-jDD"),
      fromDateMin: "",
      toDate: "",
      organ: "0",
      pan: "",
      currentPage: 1,
      pages: [1],
      perPage: 10,
      count: 0,
      type: 0,
    };
  },
  watch: {
    currentPage(value) {
      this.currentPage = value;
      this.getData();
    },
    perPage(value) {
      if (this.count == 0) return;
      if (value) this.getData();
    },

    toDate(value) {
      this.fromDateMax = this.toDate;
    },
  },
  methods: {
    handlePaginateArray(pagesCount) {
      let pagesArray = [1];
      if (pagesCount > 1) {
        if (this.currentPage > 2) pagesArray.push(this.currentPage - 1);
        if (this.currentPage > 1) pagesArray.push(this.currentPage);
        if (this.currentPage < pagesCount)
          pagesArray.push(this.currentPage + 1);
        const middle = Math.ceil(pagesCount / 2);
        if (middle > this.currentPage + 1 && middle < pagesCount - 2) {
          pagesArray.push(middle);
        }
        if (this.currentPage < pagesCount) pagesArray.push(pagesCount);
      }
      this.pages = pagesArray;
    },
    getExelPath() {
      this.showLoading = true;
      const postedData = {
        fromDate: this.fromDate.replace(/\//g, ""),
        toDate: this.toDate.replace(/\//g, ""),
        page: this.currentPage,
        perPage: this.perPage,
        organ: parseInt(this.organ),
        type: parseInt(this.type),
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("cards/GetCardTransactionExcelReport", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.fileName
            );
            let fileName = data.result.filename;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    getFullExelPath() {
      this.showLoading = true;
      const postedData = {
        fromDate: this.fromDate.replace(/\//g, ""),
        toDate: this.toDate.replace(/\//g, ""),
        page: 0,
        perPage: this.count,
        organ: parseInt(this.organ),
        type: parseInt(this.type),
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("cards/GetCardTransactionExcelReport", postedData)
        .then(({ data }) => {
          if (data.status) {
            let a = window.document.createElement("a");
            a.setAttribute(
              "href",
              "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
                data.result.fileName
            );
            let fileName = data.result.filename;
            a.setAttribute("download", fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
            this.rows = result;
            this.count = data.result.count;
            let calcPages = Math.ceil(this.count / this.perPage);
            calcPages = calcPages > 1 ? calcPages : 1;
            let pagesArray = [];
            for (let i = 1; i <= calcPages; i++) pagesArray.push(i);
            this.pages = pagesArray;
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    getData() {
      this.showLoading = true;
      const postedData = {
        fromDate: this.fromDate.replace(/\//g, ""),
        toDate: this.toDate.replace(/\//g, ""),
        page: this.currentPage,
        perPage: this.perPage,
        organ: parseInt(this.organ),
        type: parseInt(this.type),
        cardNumber: this.pan.replace(/-/g, ""),
      };
      this.$api
        .post("cards/GetOrganCardsTransactions", postedData)
        .then(({ data }) => {
          if (data.status) {
            this.rows = data.result.list;
            this.count = data.result.totalCount;
            this.isSearched = true;
            this.showLoading = false;
            let calcPages = Math.ceil(data.result.totalCount / this.perPage);
            this.handlePaginateArray(calcPages);
          }
        })
        .finally(() => {
          this.isSearched = true;
          this.showLoading = false;
        });
    },
    submit() {
      this.getData();
    },
  },
};
</script>
